if (!customElements.get('lm-vitrine-card')) {
  customElements.define('lm-vitrine-card', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const button = this.querySelector('[data-lm-flip]');
      if (!button) return;
      const frontLabel = button.querySelector('[data-lm-front-label]');
      const backLabel = button.querySelector('[data-lm-back-label]');
      button.hidden = false;
      button.addEventListener('click', () => {
        const rear = this.toggleAttribute('data-rear');
        button.setAttribute('aria-pressed', String(rear));
        frontLabel.hidden = rear;
        backLabel.hidden = !rear;
      });
    }
  });
}
